import { signal } from "@preact/signals-react";
import { Song } from "stuen-common";

export const historySongs = signal<Song[]>([]);
export const isSearcingHistory = signal<boolean>(false);
